// @flow

export const NOT_FOUND_PATH: string = '/404';
export const REGISTER_PATH: string = 'register';
